import { observable } from "mobx";
import { useState } from "react";
export function useLocalObservable(initializer, annotations) {
    return useState(function () { return observable(initializer(), annotations, { autoBind: true }); })[0];
}
//# sourceMappingURL=useLocalObservable.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-react-lite/es/useLocalObservable.js
// module id = 161
// module chunks = 1